/**
 * Attribute directive that prevents a <select> from containing an "unknown" value.
 */
angular.module('tgaAdmin').directive('selectNoUnknown', () => ({
  restrict: 'A',
  require: ['select', 'ngModel'],
  link(scope, $element, attrs, [selectCtrl, ngModelCtrl]) {
    // Extract feedback value from attribute
    const fallbackValue = attrs.selectNoUnknown;

    // Debounce callback to ensure options can populate, and that the
    // callback doesn't get called too many times.
    const callback = _.debounce(() => {
      if (selectCtrl.$isUnknownOptionSelected()) {
        // Try to set the <select> and model to a fallback value, if an <option> exists for it.
        if (selectCtrl.hasOption(fallbackValue)) {
          selectCtrl.writeValue(fallbackValue);
          ngModelCtrl.$setViewValue(fallbackValue);
          ngModelCtrl.$setValidity('selectNoUnknown', true);
        } else {
          ngModelCtrl.$setValidity('selectNoUnknown', false);
        }
      } else if (ngModelCtrl.$error.selectNoUnknown != null) {
        // Clear resolved existing validation error.
        ngModelCtrl.$setValidity('selectNoUnknown', true);
      }
    }, {
      wait: 16, // Current versions of lodash use `requestAnimationFrame` but ours doesn't so we'll fake it.
      maxWait: 1000,
    });

    scope.$watch(callback);
    scope.$on('$destroy', callback.cancel);
  },
}));
